import React from 'react';
import ContactForm from './ContactForm';
import './ContactBlock.css';

/**
 * The dark "start a conversation" card — copy on the left, booking form on
 * the right. Used as the closing section of the landing page and as the whole
 * of the standalone /contact page.
 */
const ContactBlock = ({
  id,
  title,
  lede,
  eyebrow = '// contact',
  showSubject = false,
  standalone = false,
}) => (
  <section id={id} className={`ak-contact-wrap ${standalone ? 'is-standalone' : ''}`.trim()}>
    <div className="ak-contact">
      <div>
        <p className="ak-contact-eyebrow">{eyebrow}</p>
        <h2 className="ak-contact-title">{title}</h2>
        <p className="ak-contact-lede">{lede}</p>
        <p className="ak-contact-email">
          <a href="mailto:hello@akeyreu.com">hello@akeyreu.com</a>
        </p>
      </div>
      <ContactForm showSubject={showSubject} />
    </div>
  </section>
);

export default ContactBlock;
